import { PostWinningNumber } from "./postWinningNumbers.model";
import { BetDetails } from "./betDetails.model"; 
import { NewLocation } from "./newLocation.model";
import { NewGroup } from "./newGroup.model";
import { NewLocationGroup } from "./newLocationGroup.model";
import { NewPostusers } from "./newPostusers.model";
import { ChangePassword } from "./changePassword.model";

export class ServiceReqResModel {
  constructor(
    public postWinningNumbers: PostWinningNumber = new PostWinningNumber(),
    public bettingDetails: BetDetails = new BetDetails(), 
    public newLocation: NewLocation = new NewLocation(),
    public addNewGroup: NewGroup = new NewGroup(),
    public locationGroup: NewLocationGroup = new NewLocationGroup(),
    public postCashiers: NewPostusers = new NewPostusers() ,
    public changePassword: ChangePassword = new ChangePassword()
  ) {}
}
